/**
 * Declaração de acessibilidade (§21.12, §21.6).
 *
 * UMA DECLARAÇÃO QUE SÓ LISTA CONQUISTAS É PROPAGANDA. Esta diz também o que
 * ainda NÃO foi verificado, porque é isso que permite a quem depende de leitor
 * de tela decidir se consegue trabalhar aqui — e é isso que nos obriga a
 * fechar as lacunas.
 */

import { Link } from 'react-router-dom';
import { RodapePublico } from '../components/RodapePublico';
import { t } from '../lib/i18n';

export function AcessibilidadePage(): JSX.Element {
  return (
    <div className="mx-auto min-h-screen max-w-3xl px-4 py-10">
      <h1 className="text-2xl font-semibold text-ink">{t('acessibilidade.titulo')}</h1>
      <p className="mt-2 text-sm text-ink-muted">{t('acessibilidade.intro')}</p>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('acessibilidade.verificado')}</h2>
        <ul className="mt-2 space-y-1.5 text-xs text-ink-muted">
          <li>Todo campo e todo botão têm nome acessível, conferido por teste automatizado.</li>
          <li>{t('acessibilidade.cabecalhoNivel1')}</li>
          <li>{t('acessibilidade.bateriaAxe')}<code>aria</code> válidos, papéis existentes, identificadores únicos.
          </li>
          <li>Nenhuma informação é transmitida apenas por cor no fluxo comercial principal.</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('acessibilidade.naoVerificado')}</h2>
        <ul className="mt-2 space-y-1.5 text-xs text-ink-muted">
          <li>
            <strong>Contraste medido em navegador.</strong>{t('acessibilidade.contrasteTexto')}</li>
          <li>
            <strong>{t('acessibilidade.tabulacao')}</strong>{t('acessibilidade.tabulacaoTexto')}</li>
          <li>
            <strong>{t('acessibilidade.leitorTela')}</strong> — entrar, criar oportunidade,
            aprovar uma ação —, com avaliação humana.
          </li>
          <li>
            <strong>Zoom a 200% e reflow</strong>{t('acessibilidade.zoomTexto')}</li>
        </ul>
        <p className="mt-2 text-2xs text-ink-subtle">{t('acessibilidade.naoGarantidas')}</p>
      </section>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('acessibilidade.barreira')}</h2>
        <p className="mt-2 text-xs text-ink-muted">{t('acessibilidade.descreva')}</p>
        <div className="mt-3 flex flex-wrap gap-2">
          <Link to="/contato" className="btn-primary btn-sm">{t('sobre.falarConosco')}</Link>
          <Link to="/legal" className="btn-secondary btn-sm">{t('legal.documentos')}</Link>
        </div>
      </section>

      <RodapePublico />
    </div>
  );
}
